import { useConfig } from 'wagmi';
import type { Chain } from '../configs/chains/chain.config';
export function useChains() {
  const {
    chains
  } = useConfig();
  return chains as [Chain, ...Chain[]];
}